import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import { ChevronleftMd } from 'assets/icons/Navigation/ChevronLeft/ChevronleftMd'
import { ChevronleftSm } from 'assets/icons/Navigation/ChevronLeft/ChevronleftSm'
import { ChevronrightMd } from 'assets/icons/Navigation/ChevronRight/ChevronrightMd'
import { ChevronrightSm } from 'assets/icons/Navigation/ChevronRight/ChevronrightSm'
import { useProducerLayout } from 'context/ProducerLayoutContext'
import { getProducerSidebarLinks } from 'data/producerSidebarLinks'
import useLocaleResources from 'hooks/useLocaleResources/useLocaleResources'
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { SidebarGroupType } from '../Sidebar/SidebarGroup'

interface CustomBreadcrumbItem {
    title: string
    linkTo?: string
}

export const Breadcrumbs = () => {
    const { pathname } = useLocation()
    const { breakpoint } = useProducerLayout()
    const { t, isRTL } = useLocaleResources('layout/ProducerLayout')

    const sidebarLinks = getProducerSidebarLinks(t)

    const separator = breakpoint === 'desktop'
        ? isRTL ? <ChevronleftMd color='#b1b1b1' /> : <ChevronrightMd color='#b1b1b1' />
        : isRTL ? <ChevronleftSm color='#b1b1b1' /> : <ChevronrightSm color='#b1b1b1' />

    // Function to generate breadcrumbs based on the current path
    function getBreadcrumbs(path: string): CustomBreadcrumbItem[] {
        const breadcrumbs: CustomBreadcrumbItem[] = [{ title: t('Sidebar.NavLinks.items.home'), linkTo: '/analytics' }]

        sidebarLinks.forEach((group: SidebarGroupType) => {
            group.items.forEach((item) => {
                // Check top-level item
                if (item.linkTo === path) {
                    breadcrumbs.push({ title: item.title, linkTo: item.linkTo })
                }

                // Check sub-items
                item.list.forEach((subItem) => {
                    if (subItem.linkTo === path) {
                        breadcrumbs.push(
                            { title: item.title }, // Parent item without link
                            { title: subItem.listTitle, linkTo: subItem.linkTo }
                        )
                    }
                })
            })
        })

        return breadcrumbs
    }

    const breadcrumbs = getBreadcrumbs(pathname)

    return (
        <Breadcrumb separator={separator}>
            {breadcrumbs
                .filter(crumb => crumb.linkTo)
                .map((crumb, index, items) => {
                    const isWhiteText = items.length === 1 || pathname === crumb.linkTo

                    return (
                        <BreadcrumbItem key={index} isCurrentPage={pathname === crumb.linkTo}>
                            <BreadcrumbLink
                                as={NavLink}
                                to={pathname !== crumb.linkTo ? crumb.linkTo : undefined}
                                fontSize={{ base: 14, md: 16, xl: 20 }}
                                fontWeight={isWhiteText ? { base: 500, md: 700 } : 400}
                                color={isWhiteText ? "text.white" : 'text.subtext.placeholder.light'}
                                cursor={isWhiteText ? 'default' : 'pointer'}
                            >
                                {crumb.title}
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                    )
                })}
        </Breadcrumb>
    )
}